import { EntityTypes } from './entity';

export default class AIEntityInstruction {
  tenantId: string;

  isoNormId: number;

  entityType: EntityTypes;

  code: string;

  instruction: string;

  constructor() {
    this.tenantId = '';
    this.isoNormId = 0;
    this.entityType = EntityTypes.Link;
    this.code = '';
    this.instruction = '';
  }

  // Composite key used as the row key for grid selection (matches the backend PK parts).
  get id(): string {
    return `${this.tenantId}|${this.isoNormId}|${this.entityType}|${this.code}`;
  }

  isEqual(item: AIEntityInstruction): boolean {
    if (this.tenantId !== item.tenantId) return false;
    if (this.isoNormId !== item.isoNormId) return false;
    if (this.entityType !== item.entityType) return false;
    if (this.code !== item.code) return false;
    if (this.instruction !== item.instruction) return false;

    return true;
  }

  clone(): AIEntityInstruction {
    const output = new AIEntityInstruction();
    output.tenantId = this.tenantId;
    output.isoNormId = this.isoNormId;
    output.entityType = this.entityType;
    output.code = this.code;
    output.instruction = this.instruction;

    return output;
  }
}
